import styled from 'styled-components';

import { CloseIcon } from 'app/theme/Icons/CloseIcon';
import { breakpoint } from 'app/theme/theme';

const CloseDialogIcon = styled(CloseIcon)`
  position: absolute;
  top: 2rem;
  right: 2rem;
  cursor: pointer;
  width: 1.7rem;
  height: 1.7rem;

  ${breakpoint.up.md`
    width: 2.3rem;
    height: 2.3rem;
  `}
`;

export { CloseDialogIcon };
